import { useState, useEffect } from 'react';
import { ReservationDiscountPage } from './seller/ReservationDiscountPage';
import { DesktopReservationDiscountPage } from './desktop/DesktopReservationDiscountPage';

export function ResponsiveReservationDiscountPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <ReservationDiscountPage /> : <DesktopReservationDiscountPage />;
}